<template>
  <!-- 批量申请待审批列表 -->
  <div class="batch-audit-list">
    <a-card style="margin-bottom: 10px">
      <search-view
        :renderItem="BATCH_SEARCH_SCHEMA"
        :isExpandShowOrNot="false"
        :initialValues="initSearchForm"
        @fetchSearch="handleSearch"
      ></search-view>
    </a-card>

    <a-card>
      <table-view
        :data="tableData"
        :columns="columns"
        :pagination="pageData"
        :loading="tableLoading"
        @handlePagination="handlePagination"
      >
        <template v-slot:action="{ tableRow }">
          <a-button type="link" size="small" @click="handleView(tableRow)">
            审核
          </a-button>
        </template>
      </table-view>
    </a-card>
  </div>
</template>

<script>
import { SearchView, TableView } from 'lxfintech-fe'
import cloneDeep from 'lodash/cloneDeep'
import { BATCH_SEARCH_SCHEMA } from './schema'
import { getBatchAuditList } from './api'
import { formatParamDate } from 'utils/util'

export default {
  name: 'batch-period-list',
  data() {
    const initSearchForm = {
      endTime: '',
      startTime: '',
      id: '',
    }
    const searchForm = cloneDeep(initSearchForm)
    return {
      BATCH_SEARCH_SCHEMA,
      tableLoading: false,
      initSearchForm,
      searchForm,
      tableData: [],
      columns: [
        {
          title: '序号',
          customRender: (text, record, index) => {
            return (
              (this.pageData.current - 1) * this.pageData.pageSize + index + 1
            )
          },
          width: 80,
          align: 'center',
          fixed: 'left',
        },
        {
          title: '流水号',
          dataIndex: 'bpmId',
          width: 200,
        },
        {
          title: '申请人',
          dataIndex: 'applier',
          width: 180,
        },
        {
          title: '申请日期',
          dataIndex: 'applyDate',
          width: 180,
        },
        {
          title: '审批角色',
          dataIndex: 'approveRole',
          width: 180,
        },
        {
          title: '状态',
          dataIndex: 'statusStr',
          width: 100,
          align: 'center',
        },
        {
          title: '操作',
          scopedSlots: { customRender: 'action' },
          width: 120,
          align: 'center',
          fixed: 'right',
        },
      ],
      pageData: {
        pageSize: 10,
        current: 1,
        total: 0,
        showTotal: total => `共${total}条`,
      },
      // SCROLL: { x: 1250 },
    }
  },
  mounted() {
    this._getBatchAuditList(this.initSearchForm)
  },
  methods: {
    async _getBatchAuditList(searchForm) {
      this.tableLoading = true
      const { current, pageSize } = this.pageData
      const formData = {
        ...searchForm,
        size: pageSize,
        current,
      }
      try {
        const {
          data: { total, records },
        } = await getBatchAuditList(formData)
        this.pageData.total = total
        this.tableData = records.map(item => {
          item.id = item.bpmId
          return item
        })
        this.tableLoading = false
      } catch (error) {
        console.error(error)
      }
    },
    handleSearch(data) {
      data = formatParamDate(data, data.applyRangeDate)
      delete data.applyRangeDate
      this.searchForm = data
      this.pageData.current = 1 // 设置为第一页
      this._getBatchAuditList(data)
    },
    handlePagination(pagination) {
      ;({
        current: this.pageData.current,
        pageSize: this.pageData.pageSize,
        total: this.pageData.total,
      } = pagination)
      this._getBatchAuditList(this.searchForm)
    },
    handleView(row) {
      this.$router.push({
        path: `/Item/period-batch/period-batch-approval-detail/${row.id}`,
      })
    },
  },
  components: {
    SearchView,
    TableView,
  },
}
</script>

<style></style>
